import React from 'react';

interface PillProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  > {
  color: 'neutral' | 'green' | 'red' | 'blue';
}

function DefaultPill({
  children,
  className,
  ...props
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLSpanElement>,
  HTMLSpanElement
>) {
  return (
    <span
      className={`text-xs font-semibold inline-block py-[5px] px-[10px] rounded-[5px] uppercase last:mr-0 mr-1 ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}

export default function Pill({
  className,
  color,
  children,
  ...props
}: PillProps) {
  switch (color) {
    case 'neutral':
      return (
        <DefaultPill
          className={`text-white bg-neutral-500 ${className}`}
          {...props}
        >
          {children}
        </DefaultPill>
      );
    case 'blue':
      return (
        <DefaultPill
          className={`text-white bg-mid-blue ${className}`}
          {...props}
        >
          {children}
        </DefaultPill>
      );
    case 'green':
      return (
        <DefaultPill className={`text-white bg-green ${className}`} {...props}>
          {children}
        </DefaultPill>
      );
    case 'red':
      return (
        <DefaultPill
          className={`text-white bg-[#EB5757] ${className}`}
          {...props}
        >
          {children}
        </DefaultPill>
      );

    default:
      return (
        <DefaultPill
          className={`text-neutral-600 bg-neutral-200 ${className}`}
          {...props}
        >
          {children}
        </DefaultPill>
      );
  }
}
